module.exports = __webpack_public_path__ + "img/image_placeholder.767cf274.png";